import { ViewLiveWebinarPage } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/watch'].update({
        staticData: { title: { webinar: 'Title.WatchWebinar' } },
        component: authGuard(ViewLiveWebinarPage)
    });
};
